"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var moment_1 = __importDefault(require("moment"));
var useUpdateMomentLocale = function (locale) {
    (0, react_1.useEffect)(function () {
        moment_1.default.locale(locale);
    }, [locale]);
};
exports.default = useUpdateMomentLocale;
